import Vue from "vue";
import Vuex from "vuex";
import renungan from "./modules/renungan";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    renungan
  }
});

export default store;
